import { IConditionalNode } from '../../../helpers/conditional-nodes.helpers';
import {
  CeramicsProducts,
  CeramicsPropertyName,
  CeramicsForm,
  CeramicsMaterial,
  CeramicsProcessing,
  CeramicsCementAmount,
} from './ceramics.model';

export const conditionalCeramicsProductIds: IConditionalNode<CeramicsProducts> =
  {
    property: CeramicsPropertyName.Form,
    map: {
      [CeramicsForm.BricksAndBlocks]: [
        {
          conditions: {
            [CeramicsPropertyName.Material]: CeramicsMaterial.Clay,
          },
          nodes: [
            {
              property: CeramicsPropertyName.Processing,
              map: {
                [CeramicsProcessing.Standard]: CeramicsProducts.StandardBricks,
                [CeramicsProcessing.Hardburned]:
                  CeramicsProducts.HardburnedBricks,
                [CeramicsProcessing.SecondFiring]:
                  CeramicsProducts.SecondFiringBricks,
              },
              defaults: CeramicsProducts.StandardBricks,
            },
          ],
        },
        {
          conditions: {
            [CeramicsPropertyName.Material]:
              CeramicsMaterial.ExpandedClayConcrete,
          },
          nodes: [
            {
              property: CeramicsPropertyName.CementAmount,
              map: {
                [CeramicsCementAmount.LessThan10]:
                  CeramicsProducts.ExpandedClayConcreteLessThan10,
                [CeramicsCementAmount.From10To14]:
                  CeramicsProducts.ExpandedClayConcrete10To14,
                [CeramicsCementAmount.From15To17]:
                  CeramicsProducts.ExpandedClayConcrete15To17,
                [CeramicsCementAmount.From18To24]:
                  CeramicsProducts.ExpandedClayConcrete18To24,
              },
            },
          ],
        },
        {
          conditions: {
            [CeramicsPropertyName.Material]: CeramicsMaterial.SandLime,
          },
          nodes: [CeramicsProducts.SandLimeBricks],
        },
      ],
      [CeramicsForm.BricksBeams]: CeramicsProducts.BricksBeams,
      [CeramicsForm.Tiles]: CeramicsProducts.Tiles,
    },
  };
